import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Project } from '../../lead-generation/shared/models/Project';
import { ProjectsService } from '../projects/projects.service';
import { markFormAsTouched } from '../../lead-generation/shared/reactive-forms/forEachElementInForm';

@Component({
  selector: 'cc-assign-projects',
  templateUrl: './assign-projects.component.html',
  styleUrls: ['./assign-projects.component.scss']
})
export class AssignProjectsComponent implements OnInit {
  public form: FormGroup;
  public projects: Project[];
  @Output() updateProjectIds = new EventEmitter();
  @Input() markFormAsTouched;

  constructor(private projectsService: ProjectsService, private fb: FormBuilder) {}

  ngOnInit() {
    this.projectsService.getProjects().subscribe((projects: any) => {
      this.projects = projects;
      this.fillProjectId();
    });

    this.form = this.fb.group({
      projectIds: [[], Validators.required]
    });

    this.form.get('projectIds').valueChanges.subscribe(projectIds => {
      this.updateProjectIds.next(projectIds);
    });

    this.markFormAsTouched.subscribe(result => {
      if (result) {
        markFormAsTouched(this.form);
      }
    });
  }

  selectAllProjects() {
    const projectIds = this.projects.map(project => project.id);
    this.form.controls['projectIds'].setValue(projectIds);
  }

  unselectAllProjects() {
    this.form.controls['projectIds'].setValue([]);
  }

  gotoNewProject() {}

  private fillProjectId() {
    const projectId = new URLSearchParams(window.location.search).get('ccProjectId');

    if (projectId) {
      this.form.controls.projectIds.setValue([parseInt(projectId, 10)]);
    }
  }
}
